import React from 'react';
import { useNavigate } from "react-router-dom";

export function MaterialHeader(props) {
    const navigate = useNavigate();

    const backToSearchClick = () => {
        const urlParams = new URLSearchParams(window.location.search);
        let searchPhrase = urlParams.get('fromSearch');
        if (searchPhrase === "true")
            navigate("/?search=" + localStorage.getItem("sphdsSearchPhrase") + (props.searchArchive ? "&searchArchive=true" : ""));
        else
            navigate(-1);
    };

    return <>
        <div className="gridLinkDiv">
            <a className="gridLink" onClick={backToSearchClick} onKeyDown={(e) => { if (e.code === "Enter") backToSearchClick(); }}>
                {props.localizations.BackToSearch}
            </a>
        </div>

        <div
            style={{ paddingTop: "5px", paddingLeft: "5px", fontSize: "16px" }}
            className="row"
        >
            {(props.headerFields || []).map((hf, idx) => {
                // CAS gets the formatted (dashed) string; list columns render their HTML "Display" value.
                let displayValue = hf.field === "casNumber"
                    ? props.materialData.CasNumberString
                    : (hf.isList ? props.materialData[hf.field + "Display"] : props.materialData[hf.field]);
                return (
                    <div className="col" style={{ maxWidth: "fit-content" }} key={idx}>
                        <p style={{ color: "#2b2d42", fontFamily: "Inter" }}>
                            <strong>{hf.label}:</strong>{" "}
                            {hf.isList
                                ? <span className="selectable" dangerouslySetInnerHTML={{ __html: displayValue }}></span>
                                : <span className="selectable">{displayValue}</span>}
                        </p>
                    </div>
                );
            })}
        </div>
    </>;
}